import React, { Component } from "react";
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import { Button } from 'antd';
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
            pageList: []
        }
    }
    componentDidMount(){
        this.queryAuditList();
    }
    queryAuditList(){
        WidgetAjax.ajax({
            url : Config.getBasePath()+'/entsq/audit_list', 
            params : {
                SQID: this.props.location.state.SQID,
                INFO: 'INFO'
            }, 
            callback : (data)=>{
                if(data&&data.status === 0){
                    data.results.forEach(da => {
                        if(da.HJMC==='县审核'){
                            da.HJMC = '待审核'
                        }else if(da.HJMC==='县报送'){
                            da.HJMC = '待审核'
                        }else if(da.HJMC==='市报送'){
                            da.HJMC = '待审核'
                        }else if(da.HJMC==='市报送退回'){
                            da.HJMC = '退回'
                        }else if(da.HJMC==='市报送驳回'){
                            da.HJMC = '驳回'
                        }else if(da.HJMC==='省审核'){
                            da.HJMC = '待审核'
                        }else if(da.HJMC==='省报送驳回'){
                            da.HJMC = '驳回'
                        }else if(da.HJMC==='总局'){
                            da.HJMC = '认定入库'
                        }else{
                            da.HJMC = '认定入库'
                        }
                        da.BLJG = da.BLJG.replace('市报送退回','退回').replace('县审核驳回','驳回').replace('县审核退回','退回').replace('省审核通过','认定入库').replace('市报送通过','待审核').replace('待审核通过','待审核').replace('市报送驳回','驳回').replace('省审核驳回','驳回').replace('省报送驳回','驳回').replace('县报送通过','待审核').replace('市审核退回','退回')
                    });
                    this.setState({
                        pageList: data.results
                    })
                }
            }
        },this);
    }
    onChange(value) {
        console.log(value);
    };

    render()
    {
        const {pageList} = this.state
        return (
            <div data-component="notice">
                <div className="sg-notice" style={{display:pageList&&pageList.length?'block':'none'}}>
                    {
                        pageList.map((res,index)=>{
                            let year = new Date(res.BLSJ).getFullYear()
                            return <div className="sg-notice-list">
                                <div className="sg-list-top">
                                {/* {isNaN(year)?2023:year - 1 } */}
                                    <div className="sg-top-font">{index+1}. 您{res?.ND}年度第一批申报{res.BLJG==='通过'?res.HJMC:''}{res.BLJG}{res.BLJG.indexOf('通过')===-1?',原因：':''}{res.BLJG.indexOf('通过')===-1?res.BLYJ:''}。</div>
                                </div>
                                <div className="sg-list-bottom sd-middle">
                                    <Button type="text" className="sg-center-btn">查看详情</Button>
                                </div>
                            </div>
                        })
                    }
                    
                </div>

                <div className="sg-notice" style={{display:pageList&&pageList.length?'none':'block'}}>
                    <div className="sg-notice-label sd-columnCenter">
                        <img className='sg-label-img11' alt='#' src={require('../../img/business/defined.png')} />
                        <div className="sg-label-font11">暂无申报通知</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Index
